import React from "react";
import {
  confirmationMsg,
  generateLoading,
  showAlert,
  stopLoading,
} from "../../promptMessages/PromptMessages";
import {
  reprocessToBranchText,
  reprocessToMcashText,
} from "../../lib/constants/text/Text";
import useUserLogin from "../../hooks/UserLoginhook";
import useReprocess from "../../hooks/ReprocessHook";

interface ReprocessModalProps {
  modalClose?: any;
  data?: any;
  batchNumber?: any;
  isDone?: (value: boolean) => void;
  isGenerating?: (value: boolean) => void;
  isReprocessData?: (value: any) => void;
  isTotalDisplay?: (value: any) => void;
  selectedRows?: any;
}
const ReprocessModal = ({
  modalClose,
  data,
  batchNumber,
  isDone,
  isGenerating,
  isReprocessData,
  isTotalDisplay,
  selectedRows,
}: ReprocessModalProps) => {
  const { customColor } = useUserLogin();
  const { handleMCashForceCommit } = useReprocess();

  const handleReprocessToMcashClick = async () => {
    await handleMCashForceCommit(
      data,
      batchNumber,
      isDone,
      isGenerating,
      isReprocessData,
      isTotalDisplay,
      modalClose,
      selectedRows
    );
    modalClose(false);
  };

  const handleReprocessToBranchClick = async () => {
    await handleMCashForceCommit(
      data,
      batchNumber,
      isDone,
      isGenerating,
      isReprocessData,
      isTotalDisplay,
      modalClose,
      selectedRows
    );
    modalClose(false);
  };
  const disabled = true;
  return (
    <div className="flex gap-5 w-full justify-center mx-auto px-4">
      <button
        style={{ backgroundColor: customColor }}
        className={`rounded-md  text-white p-2 text-custom-micro bg-custom-default ${
          customColor
            ? `hover:scale-105 transition-all duration-300`
            : `hover:bg-custom-default-hover hover:shadow-lg   hover:shadow-red-500/40`
        }`}
        onClick={handleReprocessToMcashClick}
      >
        Reprocess to Mcash
      </button>

      <button
        style={{ backgroundColor: customColor }}
        disabled={disabled}
        className={`rounded-md  text-white p-2 text-custom-micro bg-custom-default ${
          customColor
            ? `hover:scale-105 transition-all duration-300`
            : `hover:bg-custom-default-hover hover:shadow-lg   hover:shadow-red-500/40`
        } ${
          disabled
            ? `bg-opacity-30 opacity-50 transition-all duration-1000 cursor-not-allowed`
            : ``
        }`}
        onClick={handleReprocessToBranchClick}
      >
        Reprocess to Branch
      </button>
    </div>
  );
};

export default ReprocessModal;
